import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, PRICE } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-oportunidad" className="bg-carbon" data-id="element-54" data-mp="c7k5ny2p8nov">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-6 sm:py-7" data-id="element-55" data-mp="84nswnzublsu">
        <Reveal data-id="element-56" data-mp="m4yilnpeyucf">
          <h2 id="ultima-oportunidad" className="font-display text-2xl uppercase leading-none tracking-wide text-coral sm:text-4xl" data-id="element-57" data-mp="m4ezw4rxw1xc">
            Una última oportunidad
          </h2>
          <p className="mx-auto mt-1.5 max-w-xl text-[0.82rem] leading-snug text-beige sm:text-[0.95rem]" data-id="element-58" data-mp="vtq9dsiqn8lr">
            Puedes seguir guardando rutinas, videos y ejercicios y
            preguntándote qué deberías hacer primero.{' '}
            <span className="font-bold text-cream" data-id="element-59" data-mp="14tdb6ffdqgfc">
              O puedes comenzar hoy a construir una forma más organizada de
              entrenar siguiendo una ruta paso a paso.
            </span>
          </p>
          <p className="mt-1.5 font-script text-3xl leading-tight text-gold sm:text-4xl" data-id="element-60" data-mp="2c711dx38qnuc">
            No necesitas saberlo todo para empezar. Necesitas dar el primer
            paso.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-3 rounded-2xl border-2 border-gold bg-carbon-soft p-3.5 sm:p-5" data-id="element-61" data-mp="2r1nq95kig2ap">
          <h3 className="font-display text-xl uppercase leading-none tracking-wide text-coral sm:text-3xl" data-id="element-62" data-mp="2v2r3rlf35m8r">
            🔥 SISTEMA LOWER BODY 360°
          </h3>
          <p className="font-display text-lg uppercase tracking-wide text-cream sm:text-2xl" data-id="element-63" data-mp="34tlsqxjpuzxw">
            6 Módulos + 5 Bonos
          </p>
          <p className="mt-1.5 text-[0.74rem] font-bold uppercase text-muted sm:text-sm" data-id="element-64" data-mp="39r3t3zjo46ua">
            Valor de los bonos:{' '}
            <span className="line-through decoration-danger decoration-2" data-id="element-65" data-mp="3epf2k961wfbz">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="mt-1 text-[0.68rem] font-bold uppercase tracking-[0.24em] text-muted sm:text-xs" data-id="element-66" data-mp="1jntqzs9obvxa">
            Hoy:
          </p>
          <p className="font-impact text-5xl leading-none text-gold sm:text-6xl" data-id="element-67" data-mp="1eqjw3x3ims22">
            {PRICE}
          </p>

          <div className="mt-2.5 flex flex-col items-center gap-1.5" data-id="element-68" data-mp="1shydy0losn7j">
            <CtaButton size="lg" data-id="element-69" data-mp="1novq893lc7z9">🚀 SÍ, QUIERO COMENZAR AHORA</CtaButton>
            <p className="flex flex-wrap items-center justify-center gap-x-2 text-[0.66rem] font-bold uppercase tracking-wide text-muted sm:text-xs" data-id="element-70" data-mp="22ebg7mvas9dw">
              Acceso Inmediato
              <span aria-hidden="true" data-id="element-71" data-mp="2bfj0h10zb9oz">•</span>
              Entrega Digital
              <span aria-hidden="true" data-id="element-72" data-mp="2bdezorydmqsx">•</span>
              <span className="flex items-center gap-1" data-id="element-73" data-mp="27do2a5echcff">
                <ShieldCheckIcon size={13} className="text-gold" data-id="element-74" data-mp="27c37qfs15thk" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}